module.exports = __webpack_public_path__ + "static/media/cwiczenie-pisania-na-klawiaturze-inf2-1.52880500.png";